module.exports = __webpack_public_path__ + "img/iconfont.685fb3d5.svg";